import { Button } from "antd";

export default function InProgress() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #6454F414", backgroundColor: "#E7EAFF99" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/inprogress.svg" alt="" />
        <Button htmlType="button" className="violet-btn btn-sm" type="primary">
          Send for approval
        </Button>
      </div>
      <h5> Proposal in progress </h5>
      <h6> Complete estimate and proposal doc. </h6>
    </div>
  );
}
